exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".Onboard__pagePadding___1mpza {\n\tpadding-left: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n\tpadding-right: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n\n.Onboard__oneColumn___23ksp {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.Onboard__userNameSuggestion___N-mqC {\n\ttext-transform: none !important;\n}\n\n.Onboard__nameText___2zQOz {\n\ttext-transform: capitalize;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "Onboard__pagePadding___1mpza",
	"oneColumn": "Onboard__oneColumn___23ksp",
	"userNameSuggestion": "Onboard__userNameSuggestion___N-mqC",
	"nameText": "Onboard__nameText___2zQOz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/Onboard.icss
// module id = 1523
// module chunks = 0